import { useCallback } from 'react';
import { gsap } from 'gsap';

const useAnimations = () => {
  const tweenIn = useCallback(elements => {
    const tween = gsap.fromTo(
      elements,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.25,
        ease: 'cubic-bezier(0,0,0,0)',
      },
    );
    return tween.restart();
  }, []);

  return { tweenIn };
};

export default useAnimations;
